import { apiRequest } from "./common";

const createActivity = async (data) => {
    const response = await apiRequest('post', '/curricular-activity', data);
    return response.data;
};

const updateActivity = async (id, data) => {
    const response = await apiRequest('put', `/curricular-activity/${id}`, data);
    return response.data;
};

const deleteActivity = async (id) => {
    const response = await apiRequest('delete', `/curricular-activity/${id}`);
    return response.data;
};

const getActivities = async (studentId, currentGrade) => {
    const response = await apiRequest('get', `/curricular-activity/by-student/${studentId}?${currentGrade ? `studentGrade=${currentGrade}`: ''}`);
    return response.data;
};

const getActivityLog = async (studentId) => {
    const response = await apiRequest('get', `/activity-log/by-student/${studentId}`);
    return response.data;
};

export {
    createActivity,
    updateActivity,
    getActivities,
    deleteActivity,
    getActivityLog
}